import { render, staticRenderFns } from "./FarmZetaHubZonesView.vue?vue&type=template&id=d8ca6fb6&"
import script from "./FarmZetaHubZonesView.vue?vue&type=script&lang=ts&"
export * from "./FarmZetaHubZonesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports